module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.loading) ? _c('gmap-map', {
    ref: "googlemap",
    class: _vm.$style.googlemap,
    attrs: {
      "center": _vm.mapCenter,
      "zoom": _vm.mapZoom,
      "options": _vm.options
    }
  }, [_vm._l((_vm.mapCircles), function(loc) {
    return _c('gmap-circle', {
      key: JSON.stringify(loc),
      attrs: {
        "radius": loc.radius,
        "center": loc,
        "options": {
          fillColor: _vm.circleFill,
          fillOpacity: 0.4,
          strokeWeight: 1,
          strokeColor: '#fff',
        }
      }
    })
  }), _vm._l((_vm.mapMarkers), function(loc, index) {
    return _c('gmap-marker', {
      key: JSON.stringify(loc),
      attrs: {
        "position": loc,
        "icon": loc.icon,
        "label": loc.label
      }
    })
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1eb57424"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/locations-map/LocationsMap.vue
// module id = 916
// module chunks = 1